import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { TextAreaFormField } from '@playbookux/playbook-web-core';

import {
  Container,
  ContainerTitle,
  IconTitle,
  Title,
  QuestionIndex,
  ContainerInstruction,
  ContainerUploadButton,
} from './styles';

import ErrorMessage from '../error';
import UploadButton from '../../../../core/components/upload-file-button';

import { MAX_FILE_SIZE, SUPPORTED_IMAGE_FORMATS } from '../survey-const';

const ImageQuestion = (props) => {
  const {
    index,
    errors,
    touched,
    taskIndex,
    testType,
    question,
    setFieldValue,
    isEdit,
    onSetIsUploadDone,
  } = props;

  const [uploadError, setUploadError] = useState('');

  let label = '';

  if (testType === 'survey') {
    label = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}]` : ''}tasks.${index}.label`;
  } else {
    label = `${(taskIndex || taskIndex === 0) ? `tasks[${taskIndex}]` : ''}tasks.${index}.label`;
  }

  const handleChangeImage = (url, key) => {
    const newQuestion = {
      ...question,
      imageKey: key,
      imageUrl: url,
    };
    if (testType === 'survey') {
      setFieldValue(`surveysPages[${taskIndex}].tasks.${index}`, newQuestion);
      return;
    }
    setFieldValue(`tasks[${index}]`, newQuestion);
  };

  return (
    <Container>
      <ContainerTitle>
        <QuestionIndex>{index + 1}</QuestionIndex>
        <IconTitle src="/images/question-image.png" />
        <Title color="questionTitleImage">
          Image
        </Title>
      </ContainerTitle>
      <ContainerInstruction>
        <Title>Instructions</Title>
      </ContainerInstruction>
      <Field
        placeholder="Start typing your question"
        minWidth="100%"
        component={TextAreaFormField}
        name={label}
      />
      {!isEdit && (
        <ContainerUploadButton>
          <UploadButton
            text="Upload"
            index={index}
            onSetUploadError={setUploadError}
            endpointUrl="/presigned_url_upload_image"
            onChangeMedia={handleChangeImage}
            mediaUrl={question.imageUrl}
            mediaKey={question.imageKey}
            maxFileSize={MAX_FILE_SIZE}
            supportedFormats={SUPPORTED_IMAGE_FORMATS}
            mediaType="image"
            setIsUploadDone={onSetIsUploadDone}
          />
        </ContainerUploadButton>
      )}
      <ErrorMessage
        index={index}
        errors={errors}
        touched={touched}
        uploadError={uploadError}
      />
    </Container>
  );
};

ImageQuestion.propTypes = {
  index: PropTypes.number.isRequired,
  errors: PropTypes.shape({}).isRequired,
  touched: PropTypes.shape({}).isRequired,
  taskIndex: PropTypes.number,
  testType: PropTypes.string.isRequired,
  question: PropTypes.shape({
    imageUrl: PropTypes.string,
    imageKey: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  onSetIsUploadDone: PropTypes.func.isRequired,
};

ImageQuestion.defaultProps = {
  taskIndex: null,
  isEdit: false,
};

export default ImageQuestion;
